import { FilesPanel } from "../components/files";
import { PageHeader } from "../components/ui";

/** Company documents: license, insurance certificates, W-9, forms, brochures (on no job or contact). */
export function DocumentsPage() {
  return (
    <div className="flex flex-col gap-5">
      <PageHeader title="Company documents" description="NMT's own paperwork: license, insurance certificates, W-9, forms, and brochures. Overhead receipts land here too." />
      <FilesPanel owner={{ kind: "company", id: "company" }} />
    </div>
  );
}
